// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"d1d4a2c2","828":"f7efd863"}[chunkId] + ".chunk.js";
};